// extracted by mini-css-extract-plugin
export default {"main":"Option_main__3z-2G","icon":"Option_icon__mrUAI","invalid":"Option_invalid__v209y"};